import Service, { inject as service } from '@ember/service';

export default class CompanyCreditCommands extends Service {
  @service api;

  destroyCompanyCredit(companyCreditId) {
    return this.api.delete(`company-credits/${companyCreditId}`);
  }

  /**
   * Fetch company credits.
   * Using the page attribute will turn on paging.
   *
   * @param object
   * @returns {*}
   */
  loadCompanyCredits({
    companyId,
    page = null,
    count = null,
    includes = [],
    filters = {},
    sort = '',
    secondary_sort = '',
  }) {
    const params = {};

    if (includes) {
      params['include'] = includes.join(',');
    }

    if (page) {
      params['page'] = page;
    }

    if (count) {
      params['count'] = count;
    }

    if (filters) {
      params['filter'] = filters;
    }

    if (sort) {
      params['sort'] = sort;
    }

    if (secondary_sort) {
      params['secondary_sort'] = secondary_sort;
    }

    return this.api.request(`companies/${companyId}/company-credits`, { params });
  }

  /**
   *
   * @param companyId
   * @param amountInCents
   * @param costCodeId
   * @param memo
   * @returns {*}
   */
  storeCompanyCredit({
    companyId,
    amountInCents,
    costCodeId,
    memo = '',
  } = {}) {
    const options = {
      jsonData: {
        amount_in_cents: amountInCents,
        cost_code_id: costCodeId,
      },
    };

    if (memo) {
      options.jsonData.memo = memo;
    }

    return this.api.post(`companies/${companyId}/company-credits`, options);
  }

  /**
   *
   * @param companyCredit
   */
  updateCompanyCredit({
    companyCreditId,
    amountInCents,
    costCodeId,
    memo,
  } = {}) {
    throw new Error('Updating credits no longer supported');
  }
}
